import React, { useState } from 'react';
import styles from './Recurit.module.css';
import { Collapse } from 'reactstrap';
import { BiArrowFromTop } from 'react-icons/bi';
import RecuritData from './RecuritData.json';

const Recurit = () => {
  /* Collapse recruit */
  const [isOpen, setIsOpen] = useState(false);

  const handleClickToggle = (e) => {
    e.preventDefault();
    const { id } = e.target;
    setIsOpen((prevState) => ({ ...prevState, [id]: !prevState[id] }));
  };

  const renderBulletData = (data) => {
    return data.map((ele, idx) => <li key={idx}>{ele}</li>);
  };

  return (
    <>
      {Object.values(RecuritData).map((e) => (
        <div key={e.id}>
          <div className={styles.sectionRow} onClick={handleClickToggle} id={e.id}>
            <div id={e.id} className={styles.recuritDuration}>
              {e.duration}
            </div>
            <div id={e.id} className={styles.recuritTitleArea}>
              <div id={e.id} className={styles.recuritTitle}>
                {e.title}
              </div>
              <div id={e.id} className={styles.recuritMobileDuration}>
                {e.duration}
              </div>
            </div>
            <div id={e.id} className={styles.collapseArrowArea}>
              <BiArrowFromTop id={e.id} className={styles.collapseArrow} />
            </div>
          </div>
          <Collapse className={styles.sectionRowCollapse} isOpen={isOpen[e.id]}>
            <div className={styles.recruitDescription}>
              <div className={styles.recruitJD}>
                <div className={styles.recruitJDContents}>
                  <div className={styles.recruitContentSection}>
                    <h4 className={styles.recruitJDContentsTitle}>직무 설명</h4>
                    <ul>{renderBulletData(e.description)}</ul>
                  </div>
                  <div className={styles.recruitContentSection}>
                    <h4 className={styles.recruitJDContentsTitle}>자격 요건</h4>
                    <ul>{renderBulletData(e.req)}</ul>
                  </div>
                  <div className={styles.recruitContentSection}>
                    <h4 className={styles.recruitJDContentsTitle}>우대 사항</h4>
                    <ul>{renderBulletData(e.alpha)}</ul>
                  </div>
                  <div className={styles.recruitContentSection}>
                    <h4 className={styles.recruitJDContentsTitle}>제출 서류</h4>
                    <ul>{renderBulletData(e.docs)}</ul>
                  </div>
                </div>
                <a href={'mailto:recruit@legalengine.co.kr '} className={styles.recuritApply}>
                  <div className={styles.recuritApplyButton}>지원하기</div>
                </a>
              </div>
            </div>
          </Collapse>
        </div>
      ))}
    </>
  );
};

export default Recurit;
